// extracted by mini-css-extract-plugin
module.exports = {"empty":"nh0QC2rkdoTnxactiJGP","icon":"peIl4rr9vtLGeOnwmqu9","paymentMethod":"Lui0sjoWbf9rPeAuUDSQ"};